"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const react_hook_form_1 = require("react-hook-form");
const provider_test_id_1 = require("@dzambalaorg/provider-test-id");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const SelectInput = (props) => {
    const { disabledOptions = [], name, options = [], prefix, ...restProps } = props;
    const suffix = name.split(".").pop();
    const { testId } = (0, provider_test_id_1.useTestId)();
    const testIdProps = testId ? { "data-testid": `${testId}-${name}` } : {};
    const form = (0, react_hook_form_1.useFormContext)();
    const formValues = (0, react_hook_form_1.useWatch)();
    const error = (0, react_hook_form_1.get)(form.formState.errors, `${prefix}.${name}`);
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const localizedLabel = formatMessage({ id: `form.labels.${suffix}` });
    const localizedHelperText = error ? formatMessage({ id: error.message }, { label: localizedLabel }) : "";
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: `${prefix}.${name}`, control: form.control, render: ({ field }) => ((0, jsx_runtime_1.jsx)(ui_kit_1.Select, { labelId: `${name}-select-label`, helperText: localizedHelperText, label: localizedLabel, id: `${name}-select`, renderValue: (value) => value, ...field, value: (0, react_hook_form_1.get)(formValues, `${prefix}.${name}`), onChange: (e) => {
                form.setValue(`${prefix}.${name}`, e.target.value, { shouldTouch: true, shouldDirty: true });
            }, ...testIdProps, ...restProps, children: options.map(option => ((0, jsx_runtime_1.jsx)(ui_kit_1.Menu.Item, { value: option, disabled: disabledOptions.includes(option), children: option }, option))) })) }));
};
exports.SelectInput = SelectInput;
//# sourceMappingURL=index.js.map